import axiosRequest from "@/utils/axios-config";

const addProductReview = async (
  handshake,
  mage,
  nickname,
  title,
  detail,
  rate,
  productId
) => {
  const data = {
    review: {
      title,
      detail,
      nickname,
      ratings: [
        {
          rating_name: "Rating",
          value: 5,
        },
        {
          rating_name: "Quality",
          value: 5,
        },
      ],
      review_entity: "product",
      review_status: rate,
      entity_pk_value: productId,
    },
  };
  const config = {
    method: "post",
    url: "/productReviews/add",
    Headers: {
      Authorization: `Bearer ${handshake}`,
      mage: `Bearer ${mage}`,
    },
    data: JSON.stringify(data),
  };
  try {
    const req = await axiosRequest(config);
    return req;
  } catch (error) {
    return error;
  }
};

const getProductReviewsOld = async (handshake, sku) => {
  const config = {
    method: "get",
    url: `/product/reviews/${sku}`,
    headers: {
      Authorization: `Bearer ${handshake}`,
    },
  };
  try {
    const req = await axiosRequest(config);
    return req;
  } catch (error) {
    return error;
  }
};

const getProductReviews = async (sku, locale) => {
  const config = {
    method: "get",
    url: `https://js.testfreaks.com/onpage/abdulwahed.com${
      locale === "ar" ? "-ar" : ""
    }/reviews.json?key=${sku}`,
  };

  try {
    const req = await axiosRequest(config);
    return req;
  } catch (error) {
    return error;
  }
};

const getMultiProductsRating = async (skus, handshake)=> {
  const data = {"skus": skus}
  const config = {
    method: "post",
    url: `/tfreview/ratings`,
    headers:{
      Authorization: "Bearer " + handshake,
    },
    data: JSON.stringify(data)
  };

  try {
    const req = await axiosRequest(config);
    return req;
  } catch (error) {
    return error;
  }
}
export { addProductReview, getProductReviews, getProductReviewsOld, getMultiProductsRating };
